import { FC } from "react";
import { Admin, CustomRoutes, Resource } from "react-admin";

import { adminUsersResource } from "@/features/admin-users";
import { usersResource } from "@/features/users";
import { vettingUsersResource } from "@/features/vetting-users";
import { Analytics } from "@/features/analytics";
import {
  authProvider,
  CUSTOM_ROUTES,
  queryClient,
  RaDataProvider,
  ResourceName,
  theme,
} from "@/utils";
import {
  Group,
  GroupAdd,
  HowToReg,
  AccountBalance,
  Telegram,
  AttachMoneyRounded,
  TheaterComedy,
  ReceiptLong,
} from "@mui/icons-material";
import { LoginPage } from "@/features/login";
import { affiliateUsersResource } from "@/features/affiliate-users";
import { referralUsersResource } from "@/features/referral-users";
import { affiliatePayoutsResource } from "@/features/affiliate-payouts";
import { Route } from "react-router-dom";
import { SupportPage as Support } from "@/features/support";
import { Layouts } from "@/components";
import { eventsResource } from "@/features/events";
import { userPurchasesResource } from "@/features/user-purchases";

const ReactAdminProvider: FC = () => (
  <Admin
    queryClient={queryClient}
    theme={theme}
    authProvider={authProvider}
    dataProvider={RaDataProvider}
    layout={Layouts.Global}
    loginPage={<LoginPage />}
  >
    <Resource
      name={ResourceName.USERS}
      options={{ label: "Users" }}
      icon={Group}
      {...usersResource}
    />
    <Resource
      name={ResourceName.ADMIN_USERS}
      options={{ label: "Admin Users" }}
      icon={GroupAdd}
      {...adminUsersResource}
    />
    <Resource
      name={ResourceName.VETTING_USERS}
      options={{ label: "Vetting" }}
      icon={HowToReg}
      {...vettingUsersResource}
    />
    <Resource
      name={ResourceName.AFFILIATE_USERS}
      options={{ label: "Affiliates" }}
      icon={AccountBalance}
      {...affiliateUsersResource}
    />
    <Resource
      name={ResourceName.AFFILIATE_PAYOUTS}
      options={{ label: "Affiliate Payouts" }}
      icon={AttachMoneyRounded}
      {...affiliatePayoutsResource}
    />
    <Resource
      name={ResourceName.REFERRAL_USERS}
      options={{ label: "Referrals" }}
      icon={Telegram}
      {...referralUsersResource}
    />
    <Resource
      name={ResourceName.EVENTS}
      options={{ label: "Events" }}
      icon={TheaterComedy}
      {...eventsResource}
    />
    <Resource
      name={ResourceName.USER_PURCHASES}
      options={{ label: "User Purchases" }}
      icon={ReceiptLong}
      {...userPurchasesResource}
    />
    <CustomRoutes>
      <Route
        path={CUSTOM_ROUTES.ANALYTICS}
        element={
          <Layouts.CustomRoute
            resource={ResourceName.USERS_ANALYTICS}
            title={"Users Analytics"}
          >
            <Analytics />
          </Layouts.CustomRoute>
        }
      />
      <Route
        path={CUSTOM_ROUTES.SUPPORT}
        element={
          <Layouts.CustomRoute
            resource={ResourceName.SUPPORT}
            title={"Support"}
          >
            <Support />
          </Layouts.CustomRoute>
        }
      />
    </CustomRoutes>
  </Admin>
);

export { ReactAdminProvider };
